var e="default",r="grey",d="bordered",o="borderless";export{d as BORDERED_THEME_NAME,o as BORDERLESS_THEME_NAME,e as DEFAULT_THEME_NAME,r as GREY_THEME_NAME};
